import Api from "@/services/Index";

const registrationNumbersByFaculty = async (config) => {
    return Api.get("/student/reports/registration-numbers-by-faculty", config);
};

const registrationNumbersByFacultyOsym = async (config) => {
    return Api.get("/student/reports/registration-numbers-by-faculty-osym", config);
};

const numberOfStudentByStatus = async (config) => {
    return Api.get("/student/reports/number-of-students-by-status", config);
};

const studentsShouldTakeCourse = async (config) => {
    return Api.get("/student/slots/should-take-course", config);
};


const studentsShouldTakeCourses = async (config) => {
    return Api.get("/student/slots/should-take-courses", config);
};

const studentsShouldTakeElective = async (config) => {
    return Api.get("/student/slots/should-take-elective", config);
};

const semesterStatusAnalysis = async (config) => {
    const responseType =
        config.params.response_type == "page" ? "" : "arraybuffer";
    return Api.get("/student/reports/semester-status-analysis", {
        ...config,
        responseType,
    });
};
const undergraduateTransferYokReport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('undergraduate/transfers/yok-report',{...config, responseType: 'arraybuffer'});
}

const minorBranchDismissal = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('minor/application/course-not-registration-report',{ responseType: 'arraybuffer'});
}
const minorGraduateBranchDismissalReport = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/minor/application/major-a-graduate-major-y-active-report',{ responseType: 'arraybuffer'});
}
const dischargeReport = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/double/major/course-not-registration-report',{ responseType: 'arraybuffer'});
}

const studentStatusChanges = async (config) => {
    return Api.get('/student/reports/status-changes', config);
}

const studentNumbersByNationalityAndFaculty = async (config) => {
    return Api.get('/student/reports/student-numbers-by-nationality-and-faculty', config);
}

const table11YokReport = async (config) => {
    return Api.get('/undergraduate/transfers/table11-yok-report', { ...config, responseType: 'arraybuffer'});
}

const table11bYokReport = async (config) => {
    return Api.get('/undergraduate/transfers/table11B-yok-report', { ...config, responseType: 'arraybuffer'});
}

const coopScholarshipStudentReport = async (config) => {
    return Api.get('/student/documents/coop-scholarship/excel-export', { ...config, responseType: 'arraybuffer'});
}


export default {
    registrationNumbersByFaculty,
    numberOfStudentByStatus,
    studentsShouldTakeCourse,
    studentsShouldTakeElective,
    semesterStatusAnalysis,
    undergraduateTransferYokReport,
    studentsShouldTakeCourses,
    minorBranchDismissal,
    minorGraduateBranchDismissalReport,
    dischargeReport,
    studentStatusChanges,
    studentNumbersByNationalityAndFaculty,
    table11YokReport,
    table11bYokReport,
    coopScholarshipStudentReport,
    registrationNumbersByFacultyOsym
};
